//export const Auth_Proto = 'http://'
export const Auth_Proto = 'https://'
//export const Auth_Domain = 'apps.finanzz.in'
export const Auth_Domain = 'apps.finanzz.io'
//export const Auth_Domain = 'apps.hoffi.in'
//export const Auth_Domain = 'localhost'    
export const Auth_Port = ':5025'





